/**
 * The Operations group receives `{ plantIds: [...] }`, but a client may still be talking to an
 * older API that sends the single-plant `{ plantId }` shape, so accept both.
 */
export const parseUpdatedPlantIds = (jsonData: string): number[] => {
  const data = JSON.parse(jsonData) as { plantIds?: unknown; plantId?: unknown };
  const raw = Array.isArray(data.plantIds) ? data.plantIds : [data.plantId];

  return [...new Set(raw.filter((id): id is number => typeof id === "number" && id > 0))];
};

export const parseUpdatedShiftDate = (jsonData: string): string | null => {
  const data = JSON.parse(jsonData) as { shiftDate?: unknown };

  return typeof data.shiftDate === "string" && data.shiftDate.length > 0 ? data.shiftDate : null;
};

export const isRelevantToViewedDate = (payloadShiftDate: string | null, viewedDateIso: string | null) =>
  payloadShiftDate === null || viewedDateIso === null || payloadShiftDate === viewedDateIso;

export const plantIdsToRefresh = (jsonData: string, viewedDateIso: string | null): number[] => {
  try {
    if (!isRelevantToViewedDate(parseUpdatedShiftDate(jsonData), viewedDateIso)) return [];

    return parseUpdatedPlantIds(jsonData);
  } catch (error) {
    console.error("Failed to parse DataUpdatedAsync JSON", error);
    return [];
  }
};

export const describeUpdatedMachines = (machineNames: string[]): string | null => {
  const named = machineNames.filter(Boolean);

  if (named.length === 0) return null;
  if (named.length === 1) return `${named[0]} has been updated`;
  if (named.length <= 3) return `${named.join(", ")} have been updated`;

  return `${named.length} machines have been updated`;
};
